import { applyMiddleware, compose, createStore, Middleware } from "redux"
// @ts-expect-error TS(7016) FIXME: Could not find a declaration file for module 'redu... Remove this comment to see the full error message
import { createLogger } from "redux-logger"
import { default as thunk } from "redux-thunk"
import rootReducer from "#/redux/reducers"
import { heapMiddleware } from "#/redux/middleware/heapMiddleware"

import * as Sentry from "@sentry/browser"
import Settings from "../utils/CarrotConfig"

const configureStore = () => {
  const notProduction = process.env.NODE_ENV !== "production"
  // @ts-expect-error TS(2339) FIXME: Property '__REDUX_DEVTOOLS_EXTENSION_COMPOSE__' do... Remove this comment to see the full error message
  const reduxDevtoolsCompose = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__

  const middlewares = [thunk, heapMiddleware, sentryContextMiddleware]
  if (notProduction && Settings.LOG_REDUX_EVENTS) {
    middlewares.push(createLogger())
  }

  const composeEnhancers = notProduction && !!reduxDevtoolsCompose ? reduxDevtoolsCompose : compose

  return createStore(rootReducer, undefined, composeEnhancers(applyMiddleware(...middlewares)))
}

const obfuscateEmail = (email: string | null | undefined): string | null | undefined => {
  return email?.replace(/.*@/i, "*@")
}

const sentryContextMiddleware: Middleware = (store) => (next) => (action) => {
  const result = next(action)
  const state = store.getState()

  Sentry.setTag("employeeId", state.userInfo.employeeId)
  Sentry.setTag("companyId", state.companyInfo.companyId)

  Sentry.setContext("Member Info", {
    employeeId: state.userInfo.employeeId,
    email: obfuscateEmail(state.userInfo.email),
    partnerEmail: obfuscateEmail(state.userInfo.partnerEmail),
    personalEmail: obfuscateEmail(state.userInfo.personalEmail),
    isPosingAsMember: state.userInfo.isPosingAsMember
  })

  Sentry.setContext("Company Info", state.companyInfo)

  return result
}

export default configureStore
